import {
  IParkingPoolAvailabilityDay,
  ParkingPoolAvailabilityReasonCode,
} from '../../graphql/parkingPool/getParkingPoolAvailability'

export type DayState = 'booked' | 'full' | 'blocked'

const STATE_BY_CODE: Record<ParkingPoolAvailabilityReasonCode, DayState> = {
  ALREADY_RESERVED: 'booked',
  POOL_FULL: 'full',
  USER_RESERVATION_LIMIT: 'blocked',
  PARKING_USER_LIMIT: 'blocked',
  POOL_USER_LIMIT: 'blocked',
  PROFILE_USER_LIMIT: 'blocked',
  BEYOND_MAX_ADVANCE: 'blocked',
  IN_THE_PAST: 'blocked',
  POOL_NOT_VALID: 'blocked',
  PASS_DISABLED: 'blocked',
  NO_PARKING_ASSIGNED: 'blocked',
}

export const LEGEND_STATES: DayState[] = ['booked', 'full', 'blocked']

export const dayState = (
  reasonCode: ParkingPoolAvailabilityReasonCode | null | undefined,
  fallbackBooked: boolean,
): DayState => {
  if (reasonCode) return STATE_BY_CODE[reasonCode] ?? 'blocked'
  return fallbackBooked ? 'booked' : 'blocked'
}

export const reasonKey = (
  reasonCode: ParkingPoolAvailabilityReasonCode | null | undefined,
  state: DayState,
) => `reserve_modal.reason_${(reasonCode ?? `state_${state}`).toLowerCase()}`

export const hasUserReservationLimit = (days: IParkingPoolAvailabilityDay[]) =>
  days.some(day => day.reasonCode === 'USER_RESERVATION_LIMIT')
